import adiStatementDetailsHandler from "@NA/Handlers/ADIStatementDetailsHandler";
import adiViewMyStatementsHandler from "@NA/Handlers/ADIViewMyStatementsHandler";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
import ADIColors from "@NA/Utils/ADIColors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import siteMessage from "@insite/client-framework/SiteMessage";
import { getBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { StyledButton } from "@insite/mobius/Clickable";
import GridContainer, { GridContainerProps, GridOffset } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Link from "@insite/mobius/Link";
import LoadingOverlay from "@insite/mobius/LoadingOverlay";
import Typography from "@insite/mobius/Typography";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import getColor from "@insite/mobius/utilities/getColor";
import React, { FC, useEffect, useState } from "react";
import { ResolveThunks, connect } from "react-redux";
import { css } from "styled-components";

interface OwnProps extends WidgetProps { }

const mapStateToProps = (state: CustomApplicationState) => {
    const session = state.context.session;
    return {
        session,
        isAuthenticated: session.isAuthenticated,
    };
};

type Props = OwnProps & HasHistory & ReturnType<typeof mapStateToProps>;

const ADIViewMyStatements: FC<Props> = ({ id, session, isAuthenticated, history }) => {
    useEffect(() => {
        if (!isAuthenticated) {
            history.push("/MyAccount/SignIn?/MyAccount/PriceListRequest");
        }
    }, [isAuthenticated]);

    return (
        <StyledWrapper>
            {session.properties.priceList_Flg === "Y" ? (
                <Zone contentId={id} zoneName="Content1" />
            ) : (
                <Zone contentId={id} zoneName="Content2" />
            )}
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withHistory(ADIViewMyStatements)),
    definition: {
        group: "Basic",
        displayName: "ADI Request Price List",
    },
};

export default widgetModule;